module.exports = "<div class=\"radio pull-left\">\n\n    <formly-transclude></formly-transclude>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/layout/formly/wrappers/payment-options-radio.html
// module id = 615
// module chunks = 1